<template>
  <div style="position: relative; background-color: #ececec; width: 100vw; height: 100vh;">
    <vue-headful title="Danke" description="Aimz"/>
    <v-img :src="require('@/assets/trees.png')" style="position: absolute; opacity: 0.2;" height="100vh" width="100vw"
           position="left"></v-img>
    <div style="position: absolute; width: 100vw; height:100vh;" class="d-flex">
      <center-container class="d-flex align-center">
        <div>
          <v-container class="elevation-5 white mt-n3 mt-sm-10 mb-5 rounded-l rounded-r" style="max-width: 350px;">
            <v-row class="pt-5 pb-3">
              <v-col :cols="12">

                <!--      heading-->
                <center-container>
                  <v-img class="ma-5 mt-10" :src="require('@/assets/aimz.svg')" max-width="300"></v-img>
                </center-container>

                <center-container style="width: 100%;">
                  <div class="pt-5 pb-3" style="width: 300px;">
                    <h1 class="display-1 gelb&#45;&#45;text text-center">
                      Danke!
                    </h1>
                    <br/>
                    <p class="text-center body-2">
                      Die Abbuchung erfolgt durch Digistore24<br/><br/>
                      Du erhältst dein Passwort per Email und kannst damit sofort
                      einloggen.<br/><br/>
                      Bitte bewahre dieses Email mit dem Link zu deiner Bestellseite gut auf, denn dort kannst du
                      jederzeit dein Abo bearbeiten.
                    </p>
                    <br/>

                  </div>
                  <v-btn class="dunkelblau white--text" to="/login">Weiter zum Login</v-btn>
                </center-container>
              </v-col>
            </v-row>
          </v-container>
          <div class="text-center grey--text">
            <router-link class="grey--text body-2" to="/impressum">Impressum</router-link> |
            <router-link class="grey--text body-2" to="/datenschutz">Datenschutz</router-link>
          </div>
        </div>
      </center-container>
    </div>
  </div>
</template>

<script>
//import Logo from '@/components/Logo.vue'

import CenterContainer from "@/components/CenterContainer";

export default {
  components: {
    CenterContainer
    // Logo,
  },
  name: "Danke",
  data() {
    return {}
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    desktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    }
  }
}
</script>
